export default __webpack_public_path__ + "static/media/bkg--interiors-1.c786b1e4.jpg";